export default "__VITE_ASSET__DPrd85UQ__"